export default __webpack_public_path__ + "4f8503886e537c7059723dd59a239da0.png";